var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.84301 0.463867C2.60624 0.463867 0 3.0701 0 6.30686V26.6208C0 29.8576 2.60624 32.4638 5.84301 32.4638H16.853V19.9538H13.545V15.4499H16.853V11.6019C16.853 8.57867 18.8076 5.80286 23.31 5.80286C25.133 5.80286 26.481 5.97787 26.481 5.97787L26.375 10.1839C26.375 10.1839 25.0002 10.1709 23.5 10.1709C21.8764 10.1709 21.616 10.919 21.616 12.1609V15.4499H26.504L26.291 19.9539H21.616V32.4639H26.157C29.3938 32.4639 32 29.8576 32 26.6209V6.3069C32 3.07013 29.3938 0.463899 26.157 0.463899H5.84298L5.84301 0.463867Z","fill":"white"}));
}

Facebook.defaultProps = {"viewBox":"0 0 32 33","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
